import Querystring from 'query-string';
import Services, { HeaderUTF8Option } from './index';
import {
  STATS_SERVLET_URL,
  SEND_SERVLET_URL,
  COUNT_CONTACT_GROUP_INTERACTION_URL,
  REFRESH_CAMPAIGN_URL,
} from 'consts/api';

class ServletServices {
  continueHist({ histId }) {
    return Services.post(
      SEND_SERVLET_URL,
      Querystring.stringify({
        action: 'continueHist',
        histId,
      }),
      HeaderUTF8Option
    );
  }

  updateMessageHist(data, idHist) {
    return Services.post(`${SEND_SERVLET_URL}/updateHistMessage?histId=${idHist}`, data);
  }

  sendServlet(data) {
    return Services.post(`${SEND_SERVLET_URL}/sendAllOnServer`, data);
  }

  resendToTargetInteraction(
    data = {
      userId: 0,
      parentId: 0,
      failed: false,
      nonReply: false,
      nonClicked: false,
    }
  ) {
    const { userId, parentId, failed, nonReply, nonClicked } = data;
    return Services.post(
      `${SEND_SERVLET_URL}/resendToTargetInteraction?userId=${userId}&parentId=${parentId}`,
      { failed, nonReply, nonClicked }
    );
  }

  countContactInGroupByInteraction(
    data = {
      groupId: 0,
      campaignId: 0,
      failed: false,
      nonReply: false,
      nonClicked: false,
      target: {},
    }
  ) {
    const { groupId, campaignId, failed, nonReply, nonClicked, target } = data;
    return Services.post(
      `${COUNT_CONTACT_GROUP_INTERACTION_URL}?groupId=${groupId}&campaignId=${campaignId}`,
      { interactionDTO: { failed, nonReply, nonClicked }, target }
    );
  }

  markAsCompleted({ cpId }) {
    return Services.post(
      SEND_SERVLET_URL,
      Querystring.stringify({ action: 'completeCampaign', cpId })
    );
  }

  searchHis(data, configs) {
    return Services.post(`${STATS_SERVLET_URL}/searchHis`, data, configs);
  }

  pullRevenue(data) {
    return Services.post(`${STATS_SERVLET_URL}/pullRevenue`, data);
  }

  fetchPhoneNumber() {
    return Services.post(
      SEND_SERVLET_URL,
      Querystring.stringify({ action: 'fetchPhoneNumbers' }),
      HeaderUTF8Option
    );
  }

  pauseHist({ histId }) {
    return Services.post(
      SEND_SERVLET_URL,
      Querystring.stringify({
        action: 'cancelHist',
        histId,
      }),
      HeaderUTF8Option
    );
  }

  refreshCampaign(body = { id: '' }) {
    return Services.post(REFRESH_CAMPAIGN_URL, body);
  }

  updateCampaignDidGroup(
    body = {
      campaignDidGroupId: '',
      status: false,
    }
  ) {
    return Services.post(`/tb/api/v2/authenticated/campaign-did-group/status`, body);
  }

  toggleStatusContactGroup(
    body = {
      id: 1,
      status: true,
    }
  ) {
    return Services.post(`/tb/api/v2/authenticated/campaign-contact-group/status`, body);
  }
}

export default new ServletServices();
